import React from 'react';

export default ({
  classes,
  arrowRight,
  settingsIcon,
  mwRedirectEmail,
  verificationMessage,
  autogeneratedMWEmail,
}) => {

  return (
    <div className={classes.descriptionFont}>
      <li>1. Login to mailbox on web.</li>
      <li className={classes.alignCenter}>2. Click on&nbsp;<strong>Settings</strong>&nbsp;
        {settingsIcon}&nbsp;
        (the gear) in the upper right.
      </li>
      <li>3. Move down and select&nbsp;<strong>More settings</strong>.</li>
      <li className={`${classes.mt10} ${classes.mb10}`}>
        <img
          title='yahoo instruction'
          alt='yahoo instruction'
          width='100%'
          height='auto'
          border='none'
          src='https://clean.email/user/pages/blog/email-management/yahoo-mail-forwarding/settings-2x.jpg'>
        </img>
      </li>
      <li>4. On the left side of the <strong>More settings</strong> page, click <strong>Mailboxes</strong>.</li>
      <li>5. Under&nbsp;<strong>Mailbox List</strong>, click the address you'd like to set up forwarding for.</li>
      <li>6. On the right side, scroll down to the section titled&nbsp;<strong>Auto-forwarding</strong>.</li>
      <li>7. <strong>Enter the </strong>&nbsp;{mwRedirectEmail ? mwRedirectEmail : autogeneratedMWEmail()} and click&nbsp;<strong>Verify</strong>.</li>
      <li className={`${classes.mt10} ${classes.mb10}`}>
        <img
          title='yahoo instruction1'
          alt='yahoo instruction1'
          width='700px'
          height='auto'
          border='none'
          src='https://help-images.sanebox.com/production/1209/original/sb_Yahoo-webmail_UI_More-Settings_MailBoxes_Account-Forward_01-15_20_.png?1579084317'>
        </img>
      </li>
      <li className={`${classes.mt10} ${classes.p10}`} style={{ backgroundColor: '#EEECF8' }}>
        <strong>Note:</strong><br></br>
        If you see forwarding feature disabled:<br></br>
        <a href="https://payments.mail.yahoo.com?ncid=mbr_ympacqad00000003" target="_blank" rel="noopener noreferrer" title="Go to the Yahoo Mail Plus sign up page." data-rapid_p="1" data-ylk="elm:context_link">
        Upgrade to Yahoo Mail Plus</a> or <a href="https://checkout.yahoo.com/checkout/start/v1?sku=acc-yh-4e212013&amp;ncid=mbr_ryhacqlnk00000054" target="_blank" rel="noopener noreferrer" title="Go to the Access + Forwarding sign up page." data-rapid_p="2" data-ylk="elm:context_link">
        subscribe to Access + Forwarding</a> to use the email forwarding feature in your Settings. Automatic forwarding sends a copy of incoming messages from your Yahoo Mail account to another email address.&nbsp;
      </li>
    </div>
  );
};
